/**
 * @deprecated
 * Use ThreadsUpdated from realtime-updates/public
 */

import { default as _ThreadUpdate } from './_internal/ThreadUpdate';
export const ThreadUpdate = _ThreadUpdate;
export { default as AssignmentRemoval } from './_internal/removal/AssignmentRemoval';
export { default as FilterChangeRemoval } from './_internal/removal/FilterChangeRemoval';
export { default as HardDeletionRemoval } from './_internal/removal/HardDeletionRemoval';
export { default as InboxChangeRemoval } from './_internal/removal/InboxChangeRemoval';
export { default as MultipleRemoval } from './_internal/removal/MultipleRemoval';
export { default as ThreadStatusRemoval } from './_internal/removal/ThreadStatusRemoval';
export { default as TicketAssociationRemoval } from './_internal/removal/TicketAssociationRemoval';
export { default as UnknownRemoval } from './_internal/removal/UnknownRemoval';